import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const proDriverAgreementTemplateListQuery = graphql(`
  query ProDriverAgreementTemplateList {
    proDriverAgreementTemplates {
      id
      name
      title
      body
      revision
      is_default
      created_at
      updated_at
      createdBy {
        id
        name
      }
    }
  }
`);

export type ProDriverAgreementTemplateRecord = ResultOf<
  typeof proDriverAgreementTemplateListQuery
>["proDriverAgreementTemplates"][number];

export const proDriverAgreementTemplateRecordQuery = graphql(`
  query ProDriverAgreementTemplateRecord($id: ID!) {
    proDriverAgreementTemplate(id: $id) {
      id
      name
      title
      body
      revision
      is_default
      created_at
      updated_at
      createdBy {
        id
        name
      }
    }
  }
`);

export const proDriverAgreementMergeFieldsQuery = graphql(`
  query ProDriverAgreementMergeFields {
    proDriverAgreementMergeFields {
      token
      label
      group
    }
  }
`);

export type ProDriverAgreementMergeField = ResultOf<
  typeof proDriverAgreementMergeFieldsQuery
>["proDriverAgreementMergeFields"][number];
